import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import {loading} from 'elements/Loading'
import {Form} from 'components'
import {FieldType} from 'elements'
import {rules} from 'helpers/Validation'
import BusinessUnit from '../Model'

interface Props {
  store?: Store
  match: any
  businessUnit: BusinessUnit
}

@inject('store')
@loading<Props>(props => [
  props.match.params.id
    ? props.store!.businessUnits.read(props.match.params.id).then(businessUnit => ({businessUnit}))
    : undefined
])
export default class extends PureComponent<Props, object> {
  fields = [
    {
      name: 'name',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 3
    },
    {
      name: 'code',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 3
    },
    {
      name: 'tin',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 3
    },
    {
      name: 'description',
      type: FieldType.TextArea,
      rules: rules()
        .string(),
      size: 10
    },
    {
      name: 'image',
      type: FieldType.Image,
      accept: 'image/jpeg',
      footer: 'Imagen en los tickets, formato jpg\n recomendado 200x200px',
      size: 10
    }
  ]

  render() {
    const {businessUnit} = this.props
    const businessUnits = this.props.store!.businessUnits
    console.log('BusinessUnitsForm - render - businessUnit: ', businessUnit)
    return (
      <div>
        <Form
          /*delete={this.props.match.params.id}*/
          loading={['post@businessunits/', 'put@businessunits/', 'delete@businessunits/']}
          fields={this.fields}
          values={businessUnit}
          store={businessUnits}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/BusinessUnits/container/BusinessUnitsForm.tsx